import {join} from '../utils';
import styles from './modal.module.less';
import {Selectors} from './modal.selectors';
import {PureComponent} from 'react';

export interface CloseIconProps {
	className?: string;
	tooltip?: string;
	onClick?: () => any;
	color?: string;
}

export class CloseIcon extends PureComponent<CloseIconProps> {
	private get color() {
		return this.props.color ? this.props.color : '#000000';
	}

	public override render() {
		return <button className={join(styles.closeIcon, this.props.className)}
		               onClick={this.props.onClick}
		               title={this.props.tooltip}
		               data-cy={Selectors.CloseButton}>
			<svg width='24' height='24' viewBox='0 0 48 48'>
				<g fill='none' fillRule='evenodd'>
					<rect width='48' height='48'/>
					<path stroke={this.color} strokeWidth='4' d='M13,13 L35,35' strokeLinecap='round'
					      transform='matrix(-1 0 0 1 48 0)'/>
					<path stroke={this.color} strokeWidth='4' d='M13,13 L35,35' strokeLinecap='round'/>
				</g>
			</svg>
		</button>;
	}
}
